// -------------------------
// Types for Nested App Auth
//
// The schemas are inspired from:
// https://office.visualstudio.com/Office/_git/Office?path=/osfmos/nestedappauth/bondi/src/NestedAppAuthParser.bond&version=GBmain
export var NestedAppAuthMethodType;
(function (NestedAppAuthMethodType) {
    NestedAppAuthMethodType["UNKNOWN"] = "Unknown";
    NestedAppAuthMethodType["GET_ACTIVE_ACCOUNT"] = "GetActiveAccount";
    NestedAppAuthMethodType["GET_ALL_ACCOUNTS"] = "GetAllAccounts";
    NestedAppAuthMethodType["GET_INIT_CONTEXT"] = "GetInitContext";
    NestedAppAuthMethodType["GET_TOKEN"] = "GetToken";
    NestedAppAuthMethodType["GET_TOKEN_POPUP"] = "GetTokenPopup";
})(NestedAppAuthMethodType || (NestedAppAuthMethodType = {}));
export var NestedAppAuthErrorResponseStatus;
(function (NestedAppAuthErrorResponseStatus) {
    NestedAppAuthErrorResponseStatus["ACCOUNT_UNAVAILABLE"] = "ACCOUNT_UNAVAILABLE";
    NestedAppAuthErrorResponseStatus["DISABLED"] = "DISABLED";
    NestedAppAuthErrorResponseStatus["NESTED_APP_AUTH_UNAVAILABLE"] = "NESTED_APP_AUTH_UNAVAILABLE";
    NestedAppAuthErrorResponseStatus["NONE"] = "NONE";
    NestedAppAuthErrorResponseStatus["NO_NETWORK"] = "NO_NETWORK";
    NestedAppAuthErrorResponseStatus["PERSISTENT_ERROR"] = "PERSISTENT_ERROR";
    NestedAppAuthErrorResponseStatus["SUCCESS"] = "SUCCESS";
    NestedAppAuthErrorResponseStatus["TRANSIENT_ERROR"] = "TRANSIENT_ERROR";
    NestedAppAuthErrorResponseStatus["USER_CANCEL"] = "USER_CANCEL";
    NestedAppAuthErrorResponseStatus["USER_INTERACTION_REQUIRED"] = "USER_INTERACTION_REQUIRED";
})(NestedAppAuthErrorResponseStatus || (NestedAppAuthErrorResponseStatus = {}));
//# sourceMappingURL=NestedAppAuthServiceTypes.js.map